import { combineReducers } from 'redux';

import users from './users';
import userGroups from './userGroups';

export {
  fetchMetaSitePermissionsForUsers,
  updateMetaSitePermissionsForUser,
} from './users';
export {
  fetchMetaSitePermissionsForUserGroups,
  updateMetaSitePermissionsForUserGroup,
} from './userGroups';

export default combineReducers({
  users,
  userGroups,
});
